<template>
    <div v-if="visible" :class="['notification', type]" @click="toggleNotification"
        :style="{ width: isOpen ? '400px' : '80px' }">
        <div :class="['message_block', type, isOpenClass]">
            <div class=" message_inner">
                <span class="icon_left">
                    <template>
                        <img :src="icon" alt="notification icon" class="icon-img" />
                    </template>
                </span>
                <span class="timer">
                    <span v-if="type === 'warning'">{{ countdownDisplay }}</span>
                    <span v-else-if="type === 'info'" class="close-info">
                        {{ formattedProgress }}
                    </span>
                </span>
                <span class="message_text">{{ message }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeDifference } from '../../functions/globalUtiles';

export default {
    props: {
        message: String,
        progress: Number,
        type: {
            type: String,
            default: '',
        },
        countdown: String,
    },
    data() {
        return {
            visible: false,
            isOpen: false,
            isOpenClass: "open",
            countdownValue: this.countdown ? this.countdown * 60 : null,
            collapseTimeout: null,
            countdownInterval: null,
            progressInterval: null,
            removeTimeout: null,
            countdownTime: { minutes: 0, seconds: 0 },
        };
    },
    computed: {
        formattedProgress() {
            return this.isOpenClass === "open" ? `${this.progress || 0}%` : `${this.progress || 0}`;
        },
        countdownDisplay() {
            const { minutes, seconds } = this.countdownTime;
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },
        icon() {
            switch (this.type) {
                case 'success':
                    return "/done.svg";
                case 'error':
                    return "/error.svg"
                case 'warning':
                    return "/warning.svg"
                case 'info':
                    return "/sync.svg";
                default:
                    return "/sync.svg";
            }
        },
    },
    methods: {

        handleAutoRemoval() {
            if (this.type === 'success' || this.type === 'error') {
                this.$parent.$store.commit("SET_SYNCH_DISABLED", false);
                setTimeout(() => {
                    this.visible = false;
                    this.$parent.notifications = null
                    this.$parent.$store.commit("RESET_SYNCH_NOTIFICATIONS");
                }, 5000);
            }
        },
        toggleNotification() {
            this.isOpen = !this.isOpen;
            this.isOpenClass = this.isOpen ? "open" : "close"
        },
        startAutoCollapse() {
            this.collapseTimeout = setTimeout(() => {
                this.isOpen = false;
                this.isOpenClass = "close"
            }, 3000);
        },
        startCountdown() {
            if (this.type === 'warning' && this.message && this.countdown) {
                this.visible = true;

                this.countdownInterval = setInterval(() => {
                    const { minutes, seconds } = getTimeDifference(this.countdown);

                    if (minutes === 0 && seconds === 0) {
                        clearInterval(this.countdownInterval);
                        this.$parent.$store.commit("RESET_SYNCH_NOTIFICATIONS");
                    } else {
                        this.countdownTime = { minutes, seconds };
                    }
                }, 1000);
            }

        },
        startProgress() {
            if (this.type === 'info' && this.message && this.progress >= 0) {
                this.visible = true;
                this.$parent.$store.commit("SET_SYNCH_DISABLED", true);
            }
        },
        autoRemove() {
            this.removeTimeout = setTimeout(() => {
                this.$emit('close');
            }, 5000);
        },
    },
    mounted() {
        localStorage.setItem("synchStart", true);
        this.startAutoCollapse();
        this.handleAutoRemoval();
        // Handle auto-remove for success and error types
        if (this.type === 'success' || this.type === 'error') {
            this.visible = true;
            this.autoRemove(); // Start the removal timer for success or error types
        }

        // Start countdown if type is warning
        if (this.type === 'warning') {
            this.startCountdown();
        }
        // Start countdown if type is warning
        if (this.type === 'info') {
            this.startProgress();
        }
    },
    watch: {
        type(newType) {
            // Reinitialize behavior based on type changes
            if (newType === 'success' || newType === 'error') {
                this.handleAutoRemoval();
            }
        },
    },
    beforeDestroy() {
        clearTimeout(this.collapseTimeout);
        clearInterval(this.countdownInterval);
        clearInterval(this.progressInterval);
        clearTimeout(this.removeTimeout);
        this.$parent.notifications = null;
        localStorage.setItem("synchStart", false);
    },
};
</script>

<style lang="scss">
.notification {
    position: fixed;
    // margin-right: 18%;
}

.message_block {
    position: absolute;
    right: 20px;
    top: 0px;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    width: 90px;
    transition: width 0.5s;
    border-radius: 6px 0 6px 6px;

    .message_inner {
        flex: 0 0 450px;
        width: 440px;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 18px;
        padding: 10px 0;
        margin-left: -40px;
        transition: margin 0.5s;
    }

    .icon_left {
        border: 1px solid #FFF;
        text-align: center;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        box-sizing: border-box;
        margin-left: 5px;

        .icon-img {
            margin-top: 5px;
            height: 25px;
        }
    }


    .timer {
        padding: 0 10px;
        flex: 0 0 85px;
        text-align: center;
        width: 85px;
        margin-right: 5px;
    }
}

.open {
    width: 450px;

    &.success,
    &.error {
        .message_inner {
            margin-left: 0;

            .icon_left {
                margin-right: 15px;
            }

            .timer {
                display: none;
            }
        }
    }

    &.warning {
        width: 440px;

        .timer {
            margin-right: 5px;
        }

        .message_inner {
            margin-left: 0px;
            flex: 0 0 490px;
            width: 490px;
        }
    }

    &.info {
        width: 515px;

        .timer {
            margin-right: 5px;
        }

        .message_inner {
            margin-left: 0px;
            flex: 0 0 490px;
            width: 490px;
        }
    }
}

.close {

    &.success,
    &.error {
        .message_inner {
            height: 65px;
        }
    }

    .icon_left {
        margin-left: 0px;
    }
}

.close {

    &.success,
    &.error {
        .message_inner {
            padding: 0px 62px;
        }
    }

    .close-info {
        border: 1px solid #fff;
        border-radius: 50%;
        padding: 10px 12px;
    }
}

.close-icon_left {
    text-align: center;
    padding: 10px;
    height: 60px;
    border: 1px solid #fff;
    border-radius: 50%;

    .icon-img {
        height: 25px;
        margin-top: 10px;
        text-align: center;
    }
}

.message_block.success {
    border-right: 10px solid#28C36E;
    background: rgba(#196E55, 0.5)
}

.message_block.error {
    border-right: 10px solid #E15F64;
    background: rgba(#743C4C, 0.5)
}

.message_block.warning {
    border-right: 10px solid #ee6600;
    background: rgba(#7D4B19, 0.5)
}

.message_block.info {
    border-right: 10px solid #00C1E5;
    background: rgba(#056991, 0.5)
}
</style>
